/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       UserNotFoundImage.tsx
 * @author     Christian Ascone
 * @date       10/14/19 4:26 PM
 */

import React from 'react';
import {Image} from "react-native";

export function UserNotFoundImage(props) {
    return (
        <Image
            {...props}
            style={[props.style]}
            source={
                require('../../assets/images/user_not_found.png')
            }
        />
    );
}